module.exports = "/_next/static/images/bf670574b14300c595f7195fa2b245c9-slide2desktop.jpg.webp";